import { apiClient } from "@/services/api-client";
import { useQuery } from "@tanstack/react-query";
import { LocalStorageManager } from "@/utils/LocalStorageManager";

interface UserMeResponse {
  id: number | string;
  phone_number?: string | null;
  email?: string | null;
}

const Footer = () => {
  // Only attempt request if we appear to be authenticated
  const { data: user } = useQuery<UserMeResponse | undefined>({
    queryKey: ["me"],
    queryFn: async () => {
      try {
        return await apiClient.get<UserMeResponse>("/me");
      } catch {
        return undefined;
      }
    },
    enabled: LocalStorageManager.loggedIn(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  const displayName = user?.email ?? user?.phone_number ?? user?.id ?? "";

  return (
    <footer className="w-full text-center py-3 text-sm text-muted-foreground border-t border-border bg-background">
      {displayName ? `Logged in as: ${displayName}` : "Not logged in"}
    </footer>
  );
};

export default Footer;
